/* OGGO FW27 — local theme launch controller. No publishing or product scheduling. */
(() => {
  const parseLaunch = (value) => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(value || '') ? Date.parse(value) : NaN;
  const phaseAt = (launch, now, editor, preview) => {
    if (editor && ['teaser', 'live'].includes(preview)) return preview;
    return Number.isFinite(launch) && now >= launch ? 'live' : 'teaser';
  };
  const remaining = (launch, now) => {
    const seconds = Number.isFinite(launch) ? Math.max(0, Math.ceil((launch - now) / 1000)) : 0;
    return { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { parseLaunch, phaseAt, remaining };
  if (typeof customElements === 'undefined' || customElements.get('oggo-fw27')) return;

  customElements.define('oggo-fw27', class extends HTMLElement {
    connectedCallback() {
      this.launch = parseLaunch(this.dataset.launchAt);
      this.editor = this.dataset.editor === 'true';
      this.clockOffset = 0;
      this.onVisibility = () => { if (!document.hidden) { this.update(); this.syncClock(); } };
      document.addEventListener('visibilitychange', this.onVisibility);
      if (Number.isFinite(this.launch)) {
        const label = new Intl.DateTimeFormat(this.dataset.locale === 'en' ? 'en-GB' : 'tr-TR', { timeZone: 'Europe/Istanbul', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(this.launch);
        this.querySelectorAll('[data-launch-label]').forEach((el) => { el.textContent = label; });
      } else if (this.editor) {
        const note = this.querySelector('.editor-note');
        if (note) note.textContent = 'Geçiş tarihi geçersiz. Saat dilimi içeren ISO 8601 tarih girin. Otomatik geçiş durduruldu.';
      }
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
      this.syncClock();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.observer?.disconnect();
      this.abort?.abort();
    }
    async syncClock() {
      // Same-origin server Date reduces dependence on an incorrectly set device clock.
      // If unavailable, the browser clock remains the fallback; never block content.
      this.abort?.abort();
      this.abort = new AbortController();
      const abort = this.abort;
      const timeout = setTimeout(() => abort.abort(), 5000);
      try {
        const start = Date.now();
        const response = await fetch(this.dataset.clockUrl || '/', { method: 'HEAD', cache: 'no-store', credentials: 'same-origin', signal: abort.signal });
        const end = Date.now();
        const server = Date.parse(response.headers.get('date'));
        const age = Number(response.headers.get('age') || 0);
        if (response.ok && Number.isFinite(server) && age <= 5 && this.isConnected) {
          this.clockOffset = server + (end - start) / 2 - end;
          this.update();
        }
      } catch (_) { /* Offline/blocked HEAD: continue using the local clock. */ }
      finally { clearTimeout(timeout); }
    }
    update() {
      const now = Date.now() + this.clockOffset;
      const phase = phaseAt(this.launch, now, this.editor, this.dataset.preview);
      if (phase !== this.phase) {
        const hadPhase = Boolean(this.phase);
        const oldPanel = this.querySelector(`[data-phase="${this.phase}"]`);
        const focused = oldPanel?.contains(document.activeElement);
        this.phase = phase;
        this.observer?.disconnect();
        this.querySelectorAll('[data-phase]').forEach((panel) => { panel.hidden = panel.dataset.phase !== phase; });
        const panel = this.querySelector(`[data-phase="${phase}"]`);
        if (panel) {
          if (hadPhase && !this.editor) {
            if (focused) {
              const heading = panel.querySelector('h1');
              heading?.setAttribute('tabindex', '-1');
              heading?.focus({ preventScroll: true });
            }
            window.scrollTo({ top: 0, behavior: 'instant' });
          }
          if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
              if (entry.isIntersecting) { entry.target.classList.add('visible'); this.observer.unobserve(entry.target); }
            }), { threshold: 0.14 });
            panel.classList.add('motion-ready');
            panel.querySelectorAll('.fade').forEach((el) => this.observer.observe(el));
          }
        }
      }
      const values = remaining(this.launch, now);
      this.querySelectorAll('[data-countdown]').forEach((el) => {
        el.textContent = String(values[el.dataset.countdown] || 0).padStart(2, '0');
      });
    }
  });
})();
